module.exports = __webpack_public_path__ + "80af73613fb8ca2cf28b2a2befe9324d.pdf";